
import React, { useState } from 'react';

const Solutions: React.FC = () => {
  const [activeTab, setActiveTab] = useState('Sales');

  const solutions = {
    Sales: {
      title: 'Define and automate your sales process',
      description: 'Give your sales team the means to sell efficiently across channels with a structured and repeatable sales process. Capture, engage, convert, and grow at a consistent pace.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/sales-screen.png',
      apps: ['CRM', 'Bigin', 'Bookings', 'SalesIQ']
    },
    Marketing: {
      title: 'Engage prospects across channels',
      description: 'Build a business presence, send prospects the right messages, and get great returns on your marketing budget. Set up marketing automation through email workflows, autoresponders, and more.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/marketing-screen.png',
      apps: ['Marketing Automation', 'Campaigns', 'Forms', 'Social', 'Thrive']
    },
    Service: {
      title: 'Respond to inquiries and improve customer experience',
      description: 'Enable your teams to field customer support requests across channels, resolve problems quickly, and improve customer satisfaction. Offer remote support when an issue can\'t be solved over phone calls or live chats.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/support-screen.png',
      apps: ['Desk', 'Assist', 'Lens']
    },
    Finance: {
      title: 'Get your finances in order',
      description: 'Gain access to accounting tools that help organize your finances, track payables, and manage bills and expenses. Streamline billing processes and customer lifecycles.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/accounting-screen.png',
      apps: ['Books', 'Invoice', 'Expense', 'Checkout', 'Billing', 'Payroll']
    },
    HR: {
      title: 'Onboard and empower employees',
      description: 'Carry out key HR functions like finding new talent, managing employees, and building a strong organizational culture. Create policies, track time and attendance, and archive performance reviews.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/hr-screen.png',
      apps: ['People', 'Recruit']
    },
    Operations: {
      title: 'Manage projects and orders',
      description: 'Fulfill orders quickly, manage internal and customer-facing projects, expand your business model, and create custom apps for your unique processes. Manage orders and stock levels across multiple warehouses and channels.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/one/home/operations-screen.png',
      apps: ['Projects', 'Sprints', 'Inventory']
    }
  };

  const tabs = Object.keys(solutions);

  return (
    <section id="solutions" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            All your teams across departments. Better together as one.
          </h2>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center mb-12 border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-3 text-lg font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === tab
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              {solutions[activeTab as keyof typeof solutions].title}
            </h3>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {solutions[activeTab as keyof typeof solutions].description}
            </p>
            
            <div className="grid grid-cols-2 gap-4 mb-8">
              {solutions[activeTab as keyof typeof solutions].apps.map((app, index) => (
                <div key={index} className="flex items-center bg-white p-3 rounded-lg shadow-sm">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                    <i className="ri-apps-line text-blue-600"></i>
                  </div>
                  <span className="font-medium text-gray-900">{app}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex justify-center">
            <img 
              src={solutions[activeTab as keyof typeof solutions].image}
              alt={solutions[activeTab as keyof typeof solutions].title}
              className="w-full max-w-lg h-auto rounded-xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
